import script from "./blueimp-file-upload.vue?vue&type=script&setup=true&lang=ts"
export * from "./blueimp-file-upload.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__